import { useApiClient, type InferRequest, type InferResponse } from '../../hooks/useApiClient'

// Type aliases for API responses
export type MatchDetailResponse = InferResponse<'/supplier_rec/match/detail'>
export type MatchDetailRequest = InferRequest<'/supplier_rec/match/detail'>

/**
 * Hook for match detail data fetching without business logic
 * Following Freight pattern - just calls the API with minimal processing
 */
export function useMatchDetail() {
  const $api = useApiClient()

  /**
   * Hook for fetching detailed match data by ID
   * Simple API call without business logic
   */
  function useMatchDetailQuery(matchId: string | undefined) {
    return $api.useQuery(
      'post',
      '/supplier_rec/match/detail',
      {
        params: {
          query: {
            match_id: matchId as string,
          },
        },
      },
      {
        enabled: !!matchId,
        retry: false, // Don't retry on 422 errors
      }
    )
  }

  return {
    useMatchDetail: useMatchDetailQuery,
  }
}
